//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscFire(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3.5 14C3.5 18.69 7.31 22.5 12 22.5C16.69 22.5 20.5 18.69 20.5 14C20.5 10.63 19.03 8.41999 17.85 6.43999C16.85 8.07999 16.08 9.99999 14 9.99999C12.51 9.99999 11.07 8.84999 11.02 7.07999C9.99 8.05999 9.64 8.66999 9.43 8.97999C10.37 11.16 12.39 12 14 12C15.44 12 16.73 11.41 17.71 10.31C18.23 11.53 18.5 12.77 18.5 14C18.5 17.58 15.58 20.5 12 20.5C8.42 20.5 5.5 17.58 5.5 14C5.5 11.86 6.36 7.08999 13.65 2.59999L12.08 1.28999C10.08 2.48999 3.5 6.98999 3.5 14Z" fill="currentColor" /></svg>;
}
export default IconMiscFire;